<template>
  <v-container fluid>
    <h1>Bulk Messages</h1>
    <v-row class="justify-end mr-2">
      <v-btn to="/chats/bulk-messenger" class="text-right" color="primary">Send New Bulk Message</v-btn>
    </v-row>
    <v-card>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="ma-5"
      ></v-text-field>
      <v-data-table :headers="table.headers" :items="table.data" :search="search" :items-per-page="100">
        <template v-slot:item.text="{ item }">
          <span v-html="item.text"></span>
        </template>
        <template slot="item.actions" slot-scope="props">
          <v-btn :disabled="!!props.item.send_date" small color="red" @click="deleteMessage(props.item.id)"
            >Delete</v-btn
          >
          <v-btn small color="blue" :to="'/chats/bulk-messenger/' + props.item.id">Edit</v-btn>
        </template>
        <template v-slot:item.attachment="{ item }">
          <a v-if="item.attachment" :href="item.attachment" target="_blank">View</a>
          <span v-else>None</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { BULK_MESSAGES_QUERY, DELETE_BULK_MESSAGE_MUTATION } from "@/constants/graphql/chat/chat";
import { fancy_date_time } from "@/lib/fancy_date";

export default {
  name: "BulkMessagesView",
  data() {
    return {
      search: "",
      bulkMessages: [],
      table: {
        headers: [
          { text: "Send Date", sortable: true, value: "send_date", filterable: true },
          { text: "Title", sortable: true, value: "title", filterable: true },
          { text: "Scheduled Date", sortable: true, value: "scheduled_date", filterable: true },
          { text: "Sender", sortable: true, value: "sender", filterable: true },
          { text: "Text", sortable: false, value: "text", width: 250 },
          { text: "Attachment", sortable: false, value: "attachment" },
          { text: "Total Recipients", sortable: false, value: "total_recipients" },
          { text: "Actions", sortable: false, value: "actions" },
          { text: "Status", sortable: false, value: "status" },
        ],
        data: [],
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.getters.user.isSuperuser) {
        vm.$router.push("/chats");
      }
    });
  },
  methods: {
    async deleteMessage(id) {
      let confirm = window.confirm("Are you sure you want to delete this bulk message?");
      if (!confirm) return;

      await this.$apollo.mutate({
        mutation: DELETE_BULK_MESSAGE_MUTATION,
        variables: {
          bulkMessageId: id,
        },
      });
      this.$apollo.queries.bulkMessages.refetch();
    },
  },
  apollo: {
    bulkMessages: {
      query: BULK_MESSAGES_QUERY,
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          let data = response.data.bulkMessages;
          this.table.data = data.map((element) => {
            let status = "IN PROGRESS";
            if (element.sentAt) status = "SENT";
            else if (element.scheduledAt) status = "SCHEDULED";

            return {
              id: element.id,
              title: element.title,
              send_date: element.sentAt ? fancy_date_time(element.sentAt, "D MMMM YYYY hh:mm:ss", false) : "",
              scheduled_date: element.scheduledAt
                ? fancy_date_time(element.scheduledAt, "D MMMM YYYY hh:mm:ss", false)
                : "",
              sender: element.sender.firstName + " " + element.sender.lastName,
              text: element.messageText,
              attachment: element.attachment,
              total_recipients: element.totalRecipients,
              status: status,
            };
          });
        }
      },
    },
  },
};
</script>
